/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type BaseTitleCard_title$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PopularityTitleCard_title$ref: FragmentReference;
declare export opaque type PopularityTitleCard_title$fragmentType: PopularityTitleCard_title$ref;
export type PopularityTitleCard_title = {|
  +datePublishedFirst: ?any,
  +hasMoreAuthors: boolean,
  +title: string,
  +authors: ?$ReadOnlyArray<{|
    +id: string,
    +name: string,
  |}>,
  +popularityScore120DayHistory: ?$ReadOnlyArray<{|
    +date: ?any,
    +score: number,
  |}>,
  +$fragmentRefs: BaseTitleCard_title$ref,
  +$refType: PopularityTitleCard_title$ref,
|};
export type PopularityTitleCard_title$data = PopularityTitleCard_title;
export type PopularityTitleCard_title$key = {
  +$data?: PopularityTitleCard_title$data,
  +$fragmentRefs: PopularityTitleCard_title$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PopularityTitleCard_title",
  "type": "Title",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "datePublishedFirst",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasMoreAuthors",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "authors",
      "storageKey": null,
      "args": null,
      "concreteType": "Entity",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "popularityScore120DayHistory",
      "storageKey": null,
      "args": null,
      "concreteType": "HistoricalDailyPopularityScore",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "date",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "score",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "BaseTitleCard_title",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '39dea941f613c042f8af6db9c1e06af3';
module.exports = node;
